import React, { Component } from "react";
import ReactDOM from "react-dom";
import ReCAPTCHA from "react-google-recaptcha";
import "../styles/Modal.css";
const DELAY = 1500;

class Modal extends Component {
  constructor(props, ...args) {
    super(props, ...args);
    this.state = {
      callback: "not fired",
      value: "[empty]",
      load: false,
      expired: "false",
    };
    this._reCaptchaRef = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ load: true });
    }, DELAY);
    console.log("didMount - reCaptcha Ref-", this._reCaptchaRef);
  }

  handleChange = (value) => {
    console.log("Captcha value:", value);
    this.setState({ value });
    // if value is null recaptcha expired
    if (value === null) this.setState({ expired: "true" });
  };

  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!" });
    console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
  };

  handleInputChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  submitHandler = (e) => {
    e.preventDefault();
    this.props.handleSubmitVotes();
  };

  render() {
    if (!this.props.modalIsOpen) {
      return null;
    }

    return ReactDOM.createPortal(
      <div className="Modal">
        <div className="Modal__container">
          <button
            onClick={this.props.onCloseModal}
            className="Modal__close-button"
          >
            X
          </button>

          {this.props.errorResponse && (
            <p className="lead text-danger">Hubo error al enviar</p>
          )}

          <form
            onSubmit={this.submitHandler.bind(this)}
            onKeyPress={(event) => {
              if (event.which === 13 /* Enter */) {
                event.preventDefault();
              }
            }}
            className="mt-4"
          >
            <p className="lead">
              Por favor anota tu correo electrónico. 
              Preferentemente utiliza un correo GMAIL.
              Te enviaremos un enlace para validar tu voto.
            </p>
            <div className="form-group text-center">
              <input
                type="email"
                className={
                  !this.props.errorEmail
                    ? "form-control"
                    : "form-control is-invalid"
                }
                placeholder="Correo electrónico"
                onChange={this.props.handleInputChange}
                required
              />
              {this.props.errorEmail && (
                <small className="text-danger">No es un correo válido</small>
              )}
            </div>
            <div>
              <div className="form-group form-check">
                <input
                  name="esMayorDeEdad"
                  type="checkbox"
                  className="form-check-input"
                  onChange={this.handleInputChange}
                  required
                />
                <label className="form-check-label">
                  Soy mayor de edad. He leído y acepto los términos de su aviso
                  de privacidad.
                </label>
              </div>
              <small id="emailHelp" className="form-text text-muted pb-2">
                Nunca compartiremos tu correo electrónico con alguien más. Tu
                correo será eliminado de nuestros registros en el momento que se
                cierre la votación. Puedes consultar nuestro{" "}
                <strong>aviso de privacidad integral</strong>{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.filmoteca.unam.mx/aviso-de-privacidad/"
                  /* href="https://www.dropbox.com/s/7mapdyoq2xdyjhx/Aviso%20de%20privacidad%20DGAC%20FILMOTECA.pdf?dl=0" */
                >
                  aqui
                </a>
              </small>
            </div>
            <div className="text-center">
              <ReCAPTCHA
                style={{ display: "inline-block" }}
                theme="dark"
                ref={this._reCaptchaRef}
                sitekey="6LcCl6cUAAAAAKAGU3UtWRPbtXINFWmI89ipW4pA"
                onChange={this.handleChange}
                asyncScriptOnLoad={this.asyncScriptOnLoad}
              />
              {this.state.value !== "[empty]" &&
                !this.props.errorEmail &&
                this.state.esMayorDeEdad &&
                !this.props.loadingResponse && (
                  <button type="submit" className="btn btn-primary">
                    Enviar
                  </button>
                )}
              {this.props.loadingResponse && (
                <div className="col-lg-12 text-center">
                  <div className="lds-ripple">
                    <div />
                    <div />
                  </div>
                  <div className="d-block">
                    Enviando datos... espere un momento.
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>,
      document.getElementById("modal")
    );
  }
}
export default Modal;
